import Attention from 'assets/icons/Attention';
import useTranslation from 'common/hooks/useTranslation';
import { isEmpty } from 'lodash';
import React from 'react';

const CandidateQuestions = ({ questions }) => {
  const { t } = useTranslation('offers\\details');

  const renderAnswer = (answer) => {
    if (answer === true || answer === 'true') return t('filters.answers.yes');
    if (answer === false || answer === 'false') return t('filters.answers.no');

    if (Array.isArray(answer)) {
      if (answer.length === 0) return t('not-answered');

      return (
        <div className='flex flex-col flex-wrap'>
          {answer.map((item, idx) => (
            <span key={idx}>{item}</span>
          ))}
        </div>
      );
    }

    if (typeof answer === 'string' && answer.trim() !== '') return answer;

    if (typeof answer === 'number') return answer;

    return t('not-answered');
  };

  return (
    <>
      {isEmpty(questions) ? (
        <div className='w-full h-full bg-ghost-white p-2.5 flex flex-col flex-grow'>
          <div className='w-full bg-white p-5 flex flex-col flex-grow'>
            <div className='h-full w-full gap-6 flex flex-col justify-center items-center'>
              <Attention size='64px' color='#F16347' />
              <h1 className='text-dark-charcoal text-xl font-semibold '>
                {t('no-questions')}
              </h1>
            </div>
          </div>
        </div>
      ) : (
        <div className='w-full h-full bg-ghost-white p-2.5 flex flex-col flex-grow'>
          <div className='w-full bg-white p-5 flex flex-col flex-grow'>
            <div className='h-full w-full flex flex-col divide-y '>
              {questions.map((entry, index) => (
                <div
                  key={index}
                  className='flex flex-col w-full gap-4 px-2 py-5 first:pt-0'
                >
                  <div className='flex justify-between items-center'>
                    <div className='flex items-center gap-2'>
                      <h4 className='uppercase font-semibold text-dark-liver'>
                        {entry.question}
                      </h4>
                    </div>
                  </div>
                  {entry.description && (
                    <p className='text-sm text-cool-grey px-4'>
                      {entry.description}
                    </p>
                  )}
                  <div className='text-sm px-4'>
                    {renderAnswer(entry.answer)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CandidateQuestions;
